import React from 'react';
import * as R from 'ramda';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
import { notificationLevelOptions } from '../../../helpers/options';
// feature configs
import { MultiselectFieldComponent } from '../ui';
import ServiceVendorTableCell from '../components/service-vendor-table-cell';
//////////////////////////////////////////////////

const TRUCK_GENERAL = [
  {
    title: 'titles:general',
    fields: {
      [GC.TRUCK_REQUIRED_DOCUMENT_TYPES]: {
        type: 'list',
        options: 'documentTypes',
        component: MultiselectFieldComponent,
        name: 'titles:required-document-types',
        shouldGetInheritedValueFromConfigOptions: true,
        nameForAttribute: GC.TRUCK_REQUIRED_DOCUMENT_TYPES,
      },
      [GC.TRUCK_REQUIRED_DOCUMENT_WARNING_LEVEL]: {
        type: 'select',
        options: notificationLevelOptions(),
        name: 'titles:required-documents-warning-level',
        nameForAttribute: GC.TRUCK_REQUIRED_DOCUMENT_WARNING_LEVEL,
      },
      [GC.TRUCK_DEACTIVATE_ON_SERVICE_ISSUE]: {
        type: 'switcher',
        name: 'titles:deactivate-on-service-issue',
        nameForAttribute: GC.TRUCK_DEACTIVATE_ON_SERVICE_ISSUE,
      },
      [GC.TRUCK_DEFAULT_OUT_OF_SERVICE_REASON]: {
        type: 'select',
        options: 'outOfServiceReasons',
        name: 'titles:default-out-of-service-reason',
        nameForAttribute: GC.TRUCK_DEFAULT_OUT_OF_SERVICE_REASON,
      },
    },
  },
  {
    fields: [],
    configType: 'dropdown',
    title: 'titles:truck-type',
    editPopupTitle: 'titles:edit',
    configName: GC.TRUCK_TRUCK_TYPE,
  },
  {
    fields: [],
    configType: 'dropdown',
    editPopupTitle: 'titles:edit',
    title: 'titles:document-type',
    configName: GC.TRUCK_DOCUMENT_TYPE,
  },
  {
    fields: [],
    configType: 'dropdown',
    editPopupTitle: 'titles:edit',
    title: 'titles:insurance-type',
    configName: GC.TRUCK_INSURANCE_TYPE,
  },
  {
    fields: [],
    configType: 'dropdown',
    editPopupTitle: 'titles:edit',
    title: 'titles:unavailability-reason',
    configName: GC.TRUCK_UNAVAILABILITY_REASON,
  },
  {
    fields: [],
    configType: 'dropdown',
    editPopupTitle: 'titles:edit',
    title: 'titles:out-of-service-reason',
    configName: GC.TRUCK_OUT_SERVICE_REASON,
  },
  {
    fields: [],
    configType: 'dropdown',
    editPopupTitle: 'titles:edit',
    title: 'titles:additional-equipment-type',
    configName: GC.TRUCK_ADDITIONAL_EQUIPMENT_TYPE,
  },
  {
    fields: [],
    configType: 'dropdown',
    editPopupTitle: 'titles:edit',
    title: 'titles:specification-engine-type',
    configName: GC.TRUCK_SPECIFICATION_ENGINE_TYPE,
  },
];

export const equipmentServiceAutoCreateConfigFields = [
  {
    name: 'titles:enabled',
    tableColumnWith: '100px',
    nameForAttribute: GC.FIELD_ENABLED,
  },
  {
    name: 'titles:service-type',
    nameForAttribute: GC.FIELD_SERVICE_TYPE,
    customLogic: (_, { serviceType }) => G.getDisplayedValueFromObject(serviceType),
  },
  {
    name: 'titles:service-vendor',
    nameForAttribute: GC.FIELD_SERVICE_VENDOR_GUID,
    customLogic: (_, { serviceVendorGuid, serviceVendorName }) => (
      R.isNotNil(serviceVendorGuid) ?
        <ServiceVendorTableCell serviceVendorGuid={serviceVendorGuid} serviceVendorName={serviceVendorName} /> :
        null
    ),
  },
  {
    name: 'titles:interval',
    nameForAttribute: GC.FIELD_INTERVAL_COUNT,
  },
  {
    name: 'titles:approaching-next-service-interval',
    nameForAttribute: GC.FIELD_APPROACHING_NEXT_SERVICE_INTERVAL,
  },
  {
    name: 'titles:interval-uom',
    nameForAttribute: GC.FIELD_INTERVAL_UOM,
    customLogic: (_, { intervalUom }) => G.getUomLocale(intervalUom),
  },
];

const TRUCK_MAINTENANCE = [
  {
    title: 'titles:maintenance',
    fields: {
      [GC.TRUCK_MAINTENANCE_AI_UPLOAD_DEFAULT_DOCUMENT_TYPE]: {
        type: 'select',
        options: 'documentTypes',
        name: 'titles:ai-upload-default-document-type',
        nameForAttribute: GC.TRUCK_MAINTENANCE_AI_UPLOAD_DEFAULT_DOCUMENT_TYPE,
      },
      [GC.TRUCK_MAINTENANCE_DOCUMENTS_DEFAULT_DOCUMENT_TYPE]: {
        type: 'select',
        options: 'documentTypes',
        name: 'titles:documents-default-document-type',
        nameForAttribute: GC.TRUCK_MAINTENANCE_DOCUMENTS_DEFAULT_DOCUMENT_TYPE,
      },
    },
  },
  {
    configType: 'custom',
    title: 'titles:equipment-service-auto-create',
    hideAddition: () => G.isCurrentBranchTypeCustomer(),
    configName: GC.CUSTOM_EQUIPMENT_SERVICE_AUTO_CREATE_CONFIG,
    customConfigName: GC.CUSTOM_EQUIPMENT_SERVICE_AUTO_CREATE_CONFIG,
    fields: [
      ...equipmentServiceAutoCreateConfigFields,
      {
        tableColumnWith: '400px',
        name: 'titles:truck-types',
        nameForAttribute: GC.FIELD_TRUCK_TYPES,
        customLogic: (_, { truckTypes }) => R.join(', ', R.map(G.getDisplayedValueFromObject, truckTypes)),
      },
    ],
  },
];

const TRUCK_IFTA = [
  {
    title: 'titles:ifta',
    fields: {
      [GC.TRUCK_IFTA_EXCLUDE_FUEL_STOPS]: {
        type: 'switcher',
        name: 'titles:exclude-fuel-stops',
        nameForAttribute: GC.TRUCK_IFTA_EXCLUDE_FUEL_STOPS,
      },
    },
  },
];

const ConfigTruckGroup = {
  TRUCK_GENERAL,
  TRUCK_MAINTENANCE,
  TRUCK_IFTA,
};

export {
  ConfigTruckGroup,
};
